import { LazyImage } from '@frontend/design_system'
import loaderSrc from 'assets/img/loader.gif'
import styles from './styles.module.scss'
import { LoaderProps } from './types'

export const Loader = ({ offsetTop }: LoaderProps) => (
  <div className={styles.loader} style={{ marginTop: offsetTop }}>
    <LazyImage src={loaderSrc} width={80} height={80} isPriority />
  </div>
)
